export const rootPaths = {
  HOME: '/generator',
  LOGIN: '/generator/login',
  BRIEF: '/map/:id/:page?',
}
